module.exports = {
  REPATRIATIONS_TRANSACTIONS_EDIT_REQUEST: 'REPATRIATIONS_TRANSACTIONS_EDIT_REQUEST',
  REPATRIATIONS_TRANSACTIONS_EDIT_SUCCESS: 'REPATRIATIONS_TRANSACTIONS_EDIT_SUCCESS',
  REPATRIATIONS_TRANSACTIONS_EDIT_FAILURE: 'REPATRIATIONS_TRANSACTIONS_EDIT_FAILURE',
};
